/* eslint-disable no-unused-vars,no-console */
import ConversationService from '@/taskflex/conversations/services/ConversationService';
import MessageService from '@/taskflex/conversations/services/MessageService';
import {
    SET_CONVERSATIONS,
    SET_ACTIVE_CONVERSATION_ID,
    SET_IS_LOADING_CONVERSATION,
    SET_IS_LOADING_MESSAGES,
    SET_MESSAGES_ON_CONVERSATION, SET_IS_SENDING_MESSAGE,
} from './_types';

export default {
    loadConversation({ commit, dispatch, state }, conversationID) {
        return new Promise((resolve, reject) => {
            // Check if it already has been loaded
            const activeConversation = state.conversations
                .find(conversation => conversation.id === conversationID);

            if (activeConversation) {
                commit(SET_ACTIVE_CONVERSATION_ID, conversationID);
                return resolve(activeConversation);
            }

            // If not, load it.
            commit(SET_IS_LOADING_CONVERSATION, true);

            const options = {
                includes: ['addressee', 'sender', 'project.skill', 'latestMessage.sender'],
                sort: [
                    {
                        key: 'updated_at',
                        direction: 'desc',
                    },
                ],
            };

            return ConversationService.find(conversationID, options, (response) => {
                const { data } = response;

                commit(SET_CONVERSATIONS, [data, ...state.conversations]);
                commit(SET_ACTIVE_CONVERSATION_ID, conversationID);
                commit(SET_IS_LOADING_CONVERSATION, false);

                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },

    loadMessagesForConversation({ commit, dispatch, state }, { id }) {
        return new Promise((resolve, reject) => {
            // Check if it already has been loaded
            const activeConversation = state.conversations
                .find(conversation => conversation.id === id);

            if (!activeConversation) {
                return reject();
            }

            commit(SET_IS_LOADING_MESSAGES, true);

            const options = {
                includes: ['sender'],
                // page: this.page,
                // limit: this.limit,

                // SORT BY NEWEST LAST
                sort: [
                    {
                        key: 'created_at',
                        direction: 'asc',
                    },
                ],
            };

            return MessageService.findAll(id, options, ({ data: { rows } }) => {
                commit(SET_MESSAGES_ON_CONVERSATION, {
                    conversation: activeConversation,
                    messages: rows,
                });

                commit(SET_IS_LOADING_MESSAGES, false);

                resolve(rows);
            }, (error) => {
                reject(error);
            });
        });
    },

    sendMessageInConversation({ commit, dispatch, state }, { conversation: { id }, message }) {
        return new Promise((resolve, reject) => {
            // Check if it already has been loaded
            const activeConversation = state.conversations
                .find(conversation => conversation.id === id);

            if (!activeConversation) {
                return reject();
            }

            commit(SET_IS_SENDING_MESSAGE, true);

            const options = {
                content: message,
            };

            return MessageService.create(id, options, ({ data }) => {
                commit(SET_MESSAGES_ON_CONVERSATION, {
                    conversation: activeConversation,
                    messages: [data],
                });

                commit(SET_IS_SENDING_MESSAGE, false);

                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },

    loadConversations: async ({ commit, dispatch }) => {
        await 1;
    },

    loadEventsForConversation: async ({ commit, dispatch }, conversation) => {
        await 1;
    },

    resetAll: async ({ commit }) => {
        commit(SET_ACTIVE_CONVERSATION_ID, null);
        commit(SET_CONVERSATIONS, []);
        commit(SET_IS_LOADING_CONVERSATION, false);
        commit(SET_IS_LOADING_MESSAGES, false);
    },
};



// WEBPACK FOOTER //
// ./src/taskflex/conversations/store/_actions.js